module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNDdkNzEyOGFmMWI3Y2Q2NzA0MDNiNTZiOWIyNWQ1ZWUucG5nIjs="